<template>
    <div ref="container">
      <a-modal :title="title" width=100% :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
            <div class="table-page-search-wrapper">
            <!-- 搜索区域 -->
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入名称查询" v-model="queryParam.dictLable"></a-input>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  </a-col>
                </span>
              </a-row>
            </a-form>
          </div>
            <a-button @click="addDictData" type="primary" icon="plus">新增</a-button>
            <a-table 
                ref="table" 
                size="middle" 
                bordered rowKey="id" 
                :columns="columns" 
                :dataSource="dataSource" 
                :pagination="ipagination" 
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,columnWidth:'3%'}" 
                :scroll="{ x: 500 }"
                :loading="loading" 
                @change="handleTableChange"
            >
                <span slot="action" slot-scope="text, record">
                    <a @click="handleDataEdit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="handleDataDetele(record.id)">删除</a>
                </span>
            </a-table>
        </a-spin>
        <add-dict-data ref="addDictDatas" @close="handleClose"></add-dict-data>
      </a-modal>
      
    </div>
  </template>
  <script>
    import AddDictData from './addDictData'
    import { dictDataList, dictionaryDataList, dictDataDelete } from '@/api/api'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import Vue from 'vue'
    import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        AddDictData
    },
    data() {
      return {
        title: '操作',
        visible: false,
        confirmLoading: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        columns: [
          { title: '内容名称', dataIndex: 'dictLable', width: 70, align: 'left' },
          { title: '内容排序', dataIndex: 'dictSort', width: 70, align: 'left' },
          { title: '内容值', dataIndex: 'dictValue', width: 70, align: 'left' },
          {
            title: '备注',
            dataIndex: 'remark',
            width: 100,
            align: 'left',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: 80,
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        dictId: ''
      }
    },
    created() {},
    methods: {
        async show(record){
            console.log(record,'传递的dict表格的值==============')
            this.visible = true
            this.dictId = record.id
            await this.getDictionaryData(record.id)
            
        },
        searchQuery(){
            this.getDictionaryData(this.dictId)
        },
        searchReset(){
            this.getDictionaryData(this.dictId)
        },
        async getDictionaryData(id) {
            const params = {
                dictId: id,
                dictLable: this.queryParam.dictLable,
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize,
            }
            const res = await dictionaryDataList(params)
            if (res.code == 200  && res.success == true ) {
                this.dataSource = res.result.records
                this.queryParam.dictLable = ''
            }
        },
        //   新增
        addDictData(){
            this.$refs.addDictDatas.show(this.dictId)
        },
        //   选择父节点id
        handleChange(value){
            const selectedItem = this.parants.find(item => item.id === value);
            if (selectedItem) {
                this.form.parantId = selectedItem.id;
                this.form.parantDicName = selectedItem.dicName;
            }
        },
        handleClose(){
            this.getDictionaryData(this.dictId)
        },
        close() {
            this.$emit('close')
            this.visible = false
            
        },
        handleCancel() {
            this.close()
        },
        // 编辑
        handleDataEdit(record){
            this.$refs.addDictDatas.show(record, this.dictId)
        },
        // 删除
        async handleDataDetele(id){
            const res = await dictDataDelete({ id: id })
            if ( res.code == 200 && res.success == true ) {
                this.$message.success(res.result)
                this.getDictionaryData(this.dictId)
            }
        }
    },
  }
  </script>
  <style scoped>
  </style>